export default "__VITE_ASSET__uJlKE1th__"